import type { RegisteredUser } from "@workspace/profile";
import { getStoredJSON, setStoredJSON } from "@workspace/shared";

import { AUTH_STORAGE_KEY } from "./types";

export function getStoredUser(): RegisteredUser | null {
	return getStoredJSON<RegisteredUser>(AUTH_STORAGE_KEY);
}

export function setStoredUser(user: RegisteredUser | null): void {
	setStoredJSON(AUTH_STORAGE_KEY, user);
}

export function setStoredToken(token: { token: string; expires: Date }): void {
	setStoredJSON("token", token);
}

export function getStoredToken(): string | null {
	return (
		getStoredJSON<{ token: string; expires: Date }>("token")?.token || null
	);
}

export function setStoredRefreshToken(refreshToken: string | null): void {
	setStoredJSON("refresh_token", refreshToken);
}

export function getStoredRefreshToken(): string | null {
	return getStoredJSON<string>("refresh_token") || null;
}
